module.exports = __webpack_public_path__ + "static/media/39-7.aae39e6e.mp3";